export default function initCustomerRegistration() {
  const forms = document.querySelectorAll('.woocommerce-form-register');

  forms.forEach((form) => {
    const typeInputs = form.querySelectorAll('input[name="crispins_customer_type"]');
    const professionalFields = form.querySelector('.js-customer-registration-professional');
    const professionalInputs = form.querySelectorAll('.js-customer-registration-professional-field');
    const copyBlocks = form.querySelectorAll('.js-customer-registration-copy');
    const emailRow = form.querySelector('#reg_email')?.closest('.form-row');

    if (!typeInputs.length || !professionalFields) return;

    if (emailRow) {
      emailRow.insertAdjacentElement('afterend', professionalFields);
    }

    const updateRegistrationType = () => {
      const selected = form.querySelector('input[name="crispins_customer_type"]:checked');
      const customerType = selected ? selected.value : 'public';
      const isProfessional = customerType === 'professional';

      professionalFields.hidden = !isProfessional;
      professionalInputs.forEach((input) => {
        input.required = isProfessional;
        input.disabled = !isProfessional;
        input.setAttribute('aria-required', isProfessional ? 'true' : 'false');
      });

      copyBlocks.forEach((copy) => {
        copy.hidden = copy.dataset.customerType !== customerType;
      });
    };

    typeInputs.forEach((input) => {
      input.addEventListener('change', updateRegistrationType);
    });

    updateRegistrationType();
  });
}
